const { readsViaAgave } = require('./reads-via-agave')

// Where should a master-data read be served from?
//
// One answer for every domain, so the decision reads the same whether you are
// looking at programs, funders, locations or products:
//
// - 'pouch' — the in-process read the api has always done: the local pouch in a
//   browser, couch through the dal server-side. The answer for everyone who is
//   not online-only, and the safe fallback wherever there is no other transport
//   (a lambda, data-ops, a test).
// - 'pg'    — read Postgres directly. Only possible where a pg connection was
//   passed, which is inside agave. This is also what stops the recursion for a
//   domain whose agave handler calls the same api method it serves: resolving
//   to 'pg' there answers the request instead of calling back out.
// - 'agave' — proxy to the agave HTTP api, which reads Postgres server-side.
//   The browser answer for an online-only user, who never replicated the pouch
//   the in-process read would look in.
//
// `hasAgaveTransport` is an explicit input rather than something this infers, so
// a domain cannot forget it: for a two-way dispatch (no pg branch) it is the
// only thing standing between an online-only browser read and agave's own
// fs-api — which has no transport — calling back out to the endpoint it serves.
//
// `mustReadLocally` is for a call this particular transport cannot serve, and
// the domain decides what that means: location and product pass caller options
// their endpoints cannot honour (`{ raw: true }`, `{ resolveAlias }`), while
// program and funder options are either honoured (`programIds`) or deliberately
// server-side only (`unfiltered`), so they never set it.
const resolveReadSource = ({
  domain,
  state,
  hasPg = false,
  hasAgaveTransport = false,
  mustReadLocally = false
}) => {
  if (mustReadLocally || !readsViaAgave(state, domain)) {
    return 'pouch'
  }

  if (hasPg) {
    return 'pg'
  }

  return hasAgaveTransport ? 'agave' : 'pouch'
}

module.exports = { resolveReadSource }
